import React from "react";

import AdminLayout from "../../template/auth.layout";
import FormStep from "./components/form-step";
import CodeStep from "./components/code-step";
import { useAgentsAdminContext } from "../../providers/agents-admin.provider";
import RecoverStep from "./components/recover-step";

const AgentsAdminLoginPage = () => {
  const { step } = useAgentsAdminContext();
  return (
    <AdminLayout>
      {step === 1 && <FormStep />}
      {step === 2 && <CodeStep />}
      {step === 3 && <RecoverStep />}
    </AdminLayout>
  );
};
export default AgentsAdminLoginPage;
